import React from "react";
import { FaLeaf, FaMicroscope, FaSeedling, FaAward } from "react-icons/fa";
function Achievement() {
  return (
    <>
      <section className="achievement-section">
        <div className="achievement-wrapper">
          <div className="achievement-left">
            <span className="sub-title">Ingredient</span>
            <br />
            <br />
            <h2>Honesty in Every Ingredient</h2>
          </div>
          <div className="achievement-grid">
            <div className="achievement-card">
              <div className="icon-circlee">
                <FaLeaf />
              </div>
              <div className="text">
                <p>100% Pure & Vegan</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="icon-circlee">
                <FaMicroscope />
              </div>
              <div className="text">
                <p>Clinically Tested</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="icon-circlee">
                <FaSeedling />
              </div>
              <div className="text">
                <p>Gluten Free</p>
              </div>
            </div>

            <div className="achievement-card">
              <div className="icon-circlee">
                <FaAward />
              </div>
              <div className="text">
                <p>High Quality</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Achievement;
